module.exports = __webpack_public_path__ + "static/amex_play-3767d9f0e18184b85caba6a112b05ca9.jpg";